import request from './request'

// 获取免费课程列表
export function getFreeList(page, pagesize) {
  const url = '/course/getFreePromotionCourseList'
  return request.get(url, {
    params: {
      page: page,
      pagesize: pagesize
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/free-course.js